import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

export const APP_VERSION = "blockerfix-r2-6c4080c3";
window.__APP_VERSION__ = APP_VERSION;
// eslint-disable-next-line no-console
console.log("[Cristalda] frontend build:", APP_VERSION);


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      // Never hammer the API on auth/permission failures — a 401/403/404 will not
      // fix itself on retry and caused an anonymous-user request loop.
      retry: (failureCount, error) => {
        const status = error?.response?.status;
        if (status === 401 || status === 403 || status === 404) return false;
        return failureCount < 2;
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
